/**
 * Hook pour gérer la navigation entre les onglets du Dashboard
 * @module dashboard/hooks/useTabNavigation
 */

import { useState, useCallback, useRef, useEffect } from 'react';
import { storage } from '../../../utils/storage';
import { STORAGE_KEYS } from '../../../config/constants';

/**
 * Hook de gestion de la navigation par onglets
 * @returns {Object} État et fonctions pour la navigation
 */
export const useTabNavigation = () => {
  const [activeTab, setActiveTab] = useState(() => {
    const stored = storage.getString(STORAGE_KEYS.ACTIVE_TAB) || 'overview';
    return stored === 'chat' ? 'overview' : stored;
  });
  const [isTransitioning, setIsTransitioning] = useState(false);
  const activeTabRef = useRef(activeTab);

  // Mettre à jour la ref quand activeTab change
  useEffect(() => {
    activeTabRef.current = activeTab;
  }, [activeTab]);

  /**
   * Change l'onglet actif avec animation de transition
   * @param {string} tab - Nom de l'onglet
   */
  const switchTab = useCallback(
    (tab) => {
      if (tab !== activeTab && !isTransitioning) {
        setIsTransitioning(true);

        // Petit délai pour l'animation de sortie
        setTimeout(() => {
          setActiveTab(tab);
          storage.setString(STORAGE_KEYS.ACTIVE_TAB, tab);
          setIsTransitioning(false);
        }, 150);
      }
    },
    [activeTab, isTransitioning]
  );

  return {
    activeTab,
    isTransitioning,
    activeTabRef,
    switchTab,
  };
};
